export default __webpack_public_path__ + "static/media/org-icon.73bf5cbe.png";